import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Col, Container, Row, Image, Alert, Stack} from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
// import { MdOutlineSpeed } from 'react-icons/md';

const Overview = () => {
  return (
    <Container className="py-4 px-4">
		<Helmet>
			<title>Overview - QuickyChat</title>
			<meta name="description" content="Easily customize your chatbot to reflect your brand with QuickyChat. Build with a knowledge base, customize appearance, and more." />
			<meta name="keywords" content="chatbot, AI, customize, brand, knowledge base, deployment, chat history" />
		</Helmet>
		<Row className='py-4' style={{maxWidth:'800px',margin:'0 auto'}}>
			<h1 className='big-header'>Easily Customize Your Chatbot to Reflect Your Brand</h1>
		</Row>
		<Row >
			<Image 
				src='/images/configure-appearance.png'
				className='border border-light rounded'
				fluid />
		</Row>
		<Stack style={{maxWidth:'900px',margin:'0 auto'}}>
			<Row className="py-5">
				<Col md={6} sm={6}>
					<div className="mb-4">
						<h5>Build with Knowledge Base</h5>
						<p>
							By providing access to your knowledge base, you can build an
							AI chatbot that learns from your data and answer product
							questions like a human.
						</p>
						<Alert variant="info">
							Our platforms enables you to refined scraped data from your website links to enhance accuracy and reliability.
						</Alert>
					</div>
				</Col>
				<Col md={6} sm={6}>
					<div className="card">
						<Image src='/images/knowledgebase-3.png' fluid/>
					</div>
				</Col>
			</Row>
			<Row className="py-4" gutter={2}>
				<Col md={{span: 6, order: 1}} xs={{span: 12, order:2}}>
					<div className="">
						<Image src='/images/chatbot-3.png' fluid className='rounded'/>
					</div>
				</Col>
				<Col md={{span: 6, order: 2}} xs={{span: 12, order:1}}>
					<div className="mb-4">
						<h5 className="card-title">Customize Your Chatbot</h5>
						<p className="card-text">
							Set the color and profile photo of your chatbot to reflect your
							brand identity.
						</p>
					</div>
				</Col>
			</Row>
			{/* <Row className="py-4">
				<Col className='text-center' md={6}>
					<img
						src="https://via.placeholder.com/300x200"
						alt="Knowledge Base"
						className="card-img-top"
					/>
				</Col>
				<Col md={6}>
					<div className="mb-4">
						<h5 className="card-title">Ready in 5 Minutes</h5>
						<p className="card-text">
							Wait less than 5 minutes for your chatbot to learn all
							information from your website. Start interacting instantly!
						</p>
					</div>
				</Col>
			</Row> */}

			<Row className="py-4">
				<Col md={6}>
					<div className="mb-4">
						<h5 className="card-title">Access to Chat History</h5>
						<p className="card-text">
							Review your chatbot's conversation history with customers and
							use the content to improve your chatbot.
						</p>
					</div>
				</Col>
				<Col md={6}>
					<div className="card">
						<img
						src="/images/chat-history.png"
						alt="Knowledge Base"
						className="card-img-top"
						/>
					</div>
				</Col>
			</Row>
			<Row className="py-4">
				<Col md={{span: 6, order: 1}} xs={{span: 12, order:2}}>
					<div className="card">
						<img
						src="/images/deploy-script.png"
						alt="Knowledge Base"
						className="card-img-top"
						/>
					</div>
				</Col>
				<Col md={{span: 6, order: 2}} xs={{span: 12, order:1}}>
					<div className="mb-4">
						<h5 className="card-title">Ease of Deployment</h5>
						<p className="card-text">
							Easily embed your chatbot by copying and pasting a simple code
							snippet into your page.
						</p>
					</div>
				</Col>
			</Row>
			
			{/* <Row className="py-4">
				<Col md={6}>
					<div className="">
						<h5 className="card-title">Get Customer Feedback</h5>
						<p className="card-text">
							Monitor your chatbot's efficacy by checking how many customers
							rate its responses and interact with it.
						</p>
					</div>
				</Col>
				<Col md={6}>
					<div className="card">
						<img
						src="https://via.placeholder.com/300x200"
						alt="Knowledge Base"
						className="card-img-top"
						/>
					</div>
				</Col>
			</Row> */}
			{/* Call to Action */}
			<Row className="text-center py-5">
				<h3 className="mb-3">Ready to Get Started?</h3>
				<p>
					Sign up today and begin creating intelligent, customized AI chatbots that work for you.
				</p>
				<Link to="/dashboard">
					<Button variant="primary" size="lg">
						Start Building for Free
					</Button>
				</Link>
			</Row>
		</Stack>
    </Container>
  );
};

export default Overview;
